<template>
  <div class="wrap">
    <el-date-picker
      class="area"
      v-model="inputValue"
      :placeholder="realPlaceholder"
      :type="type"
      value-format="yyyy-MM-dd"
      :clearable="true"
      :editable="false"
      :range-separator="inputValue ? '-' : ''"
      :picker-options="pickerOptions"
      @focus="inputFocus"
      @onPick="onPick"
      @blur="inputBlur">
    </el-date-picker>
    <label v-if="isLabel" class="title" :class="change">
      <span v-if="isImportant" class="important">*</span>
      <span>{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
// 获取这个组件的输入数据，在调用的地方传入 @getdata=“xxxxx”  这个函数会返回输入域的输入，每次组件失焦的时候会自动更新
export default {
  data() {
    return {
      change: '',
      errorSignal: false,
    }
  },

  props: {
    value: {},

    type: {
      type: String,
      default: 'date'
    },

    placeholder: {
      type: String,
      default: '请输入'
    },

    isLabel: {
      type: Boolean,
      default: true
    },

    isImportant: {
      type: Boolean,
      default: true
    },

    pickerOptions: {
      type: Object,
      default: function() {
        return {}
      }
    },
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    realPlaceholder() {
      if (this.isLabel) {
        return ''
      }
      return this.placeholder
    }
  },

  methods: {
    inputFocus() {
      this.change = 'focus'
    },

    inputBlur() {
      if (this.inputValue) {
        this.change = 'blur'
      } else {
        this.change = ''
      }
    },

    onPick(date) {
      this.$emit('onPick', date)
    }
  },

  watch: {
    inputValue: {
      handler: function(val) {
        // 这种情况说明是外部赋值致使input的值发生改变 (表单回填)
        if (val && !this.change) {
          this.change = 'blur'
        } else {
          this.change = ""
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input {
  width: 100%;
}

/deep/ .el-range-editor.el-input__inner {
  width: 100%;
}
.wrap {
  position: relative;

  .area {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333333;
  }

  .title {
    position: absolute;
    left: 28px;
    top: 18px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all .25s;
    pointer-events: none;
  }

  .important {
    position: relative;
    top: 3px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #E51C23;
  }

  .focus {
    left: 13px;
    font-size: 12px;
    color: #08A681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transition: all .25s;

    transform: translate(-2px, -22px);
  }

  .blur {
    left: 13px;
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transition: all .25s;

    transform: translate(-2px, -22px);
  }
}
</style>
